import { css } from 'styled-components';

export const CustomerSendVerificationPopup = css(({ theme }) => {
  return css`
    z-index: 999;
    width: 432px;
    height: 388px;

    > .popup {
      padding: 80px 32px 0 32px;
      display: flex;
      flex-direction: column;

      > .dialog-title {
        padding: 0;
        margin-bottom: 50px;
        font-size: 21px;
        font-weight: 700;
        line-height: 32px;
      }

      > .popup-content {
        flex-grow: 1;
        margin-bottom: 60px;
        display: flex;
        flex-direction: column;
        padding: 0 70px;
        text-align: center;
      }

      .footer {
        display: flex;
        align-items: center;
        flex-direction: column;
        margin: auto 30px 0 30px;
        font-size: 14px;
        line-height: 21px;

        > .send-again-title {
          font-weight: 600;
        }

        > .send-again {
          color: ${theme.colors.primaryBright};

          > .send-again-text {
            cursor: pointer;
            font-weight: 600;
          }
        }

        > .send-again.disabled {
          color: ${theme.colors.disabledText};
          pointer-events: none;
        }
      }
    }
  `;
});
